import ExtendedPropertyList from "./ExtendedPropertyList";

export default ExtendedPropertyList;
